import React from "react";

const Block = (props) => <div className={`block ${props.className || ""}`}>{props.children}</div>;
export default Block;
